import classNames from 'classnames';

const Paragraph = ({ children, lang, className }) => {
  return <p className={classNames(lang === 'kr' && 'leading-[1.45]', 'mx-[8%] lg:mx-0', className)}>{children}</p>;
};

export default Paragraph;
